import { render } from "./GreeningOfOffices.vue?vue&type=template&id=07d6a9dc&scoped=true"
import script from "./GreeningOfOffices.vue?vue&type=script&lang=js"
export * from "./GreeningOfOffices.vue?vue&type=script&lang=js"

import "./GreeningOfOffices.vue?vue&type=style&index=0&id=07d6a9dc&scoped=true&lang=scss"

import exportComponent from "D:\\web\\OpenServer\\domains\\lembergflowers\\lembergflowers\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07d6a9dc"]])

export default __exports__